import {
    apiRequest,
    rekapDetail,
    hukdisCreate
} from "../../../../../services/adapters/kepegawaian/rekapKetidakhadiranService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", rekapDetail, {
            params: query
        }, true)
    }

    fetchCreate = async (query) => {
        return await apiRequest("post", hukdisCreate, {
            body: query
        }, true)
    }
}

export default DetailRepository